import { createSlice } from "@reduxjs/toolkit";
import { topCitiesAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const topCitiesSlice = createSlice({
  name: "topCities",
  initialState: data,
  reducers: {
    topCitiesSlice(state) {
      state.isLoading = false;
    },
    topCitiesSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    topCitiesSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    topCitiesSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const topCitiesHandler = (stateName="") => async (dispatch: any) => {
  try {
    dispatch(topCitiesAction.topCitiesSlice());
    const response: any = await topCitiesAPI(stateName);
    dispatch(topCitiesAction.topCitiesSliceSuccess(response));
  } catch (e: any) {
    dispatch(topCitiesAction.topCitiesSliceFailure(e?.response?.data?.message));
    dispatch(topCitiesAction.topCitiesSliceReset());
  }
};
export default topCitiesSlice.reducer;
export const topCitiesAction = topCitiesSlice.actions;
